var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKorean16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-lang-ko 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-lang-ko"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.7586 13.18H1.24139C1.10809 13.18 1 13.0719 1 12.9386V4.24896C1 4.11566 1.10809 4.00757 1.24139 4.00757H14.7586C14.8919 4.00757 15 4.11566 15 4.24896V12.9386C15 13.0719 14.8919 13.18 14.7586 13.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.34008 6.58484C8.23093 5.84544 6.73285 6.14772 5.99391 7.25493C5.62327 7.80757 5.77393 8.55851 6.32846 8.92823C6.88259 9.29794 7.63112 9.1478 8.00084 8.59321C8.37055 8.03865 9.11958 7.89037 9.67367 8.25814C10.2287 8.62786 10.378 9.3788 10.0077 9.93144C10.7472 8.82238 10.4483 7.32427 9.34008 6.58484Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.99392 7.25513C5.62327 7.80777 5.77394 8.55871 6.32847 8.92843C6.88259 9.29814 7.63113 9.148 8.00084 8.59341C8.37055 8.03885 9.11958 7.89057 9.67368 8.25834C10.2287 8.62806 10.378 9.379 10.0077 9.93164C9.26929 11.0427 7.7717 11.3412 6.66256 10.6018C5.55442 9.86238 5.25452 8.36427 5.99392 7.25513Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M10.5681 5.67324L11.0066 6.33227C11.0434 6.38765 11.0285 6.4624 10.9733 6.4994L10.8621 6.57386C10.8066 6.61099 10.7315 6.59606 10.6945 6.5405L10.2555 5.88162C10.2186 5.8262 10.2335 5.7513 10.2889 5.71431L10.4007 5.63971C10.4562 5.60266 10.5312 5.61767 10.5681 5.67324Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M11.2446 6.68917L11.6845 7.3478C11.7216 7.40342 11.7064 7.47867 11.6506 7.51553L11.539 7.58933C11.4836 7.62597 11.409 7.6109 11.3721 7.55569L10.9325 6.89775C10.8954 6.84235 10.9103 6.7674 10.9657 6.73035L11.0771 6.65587C11.1326 6.61881 11.2075 6.63372 11.2446 6.68917Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M11.0376 5.35992L12.154 7.03536C12.1909 7.09081 12.1759 7.16573 12.1205 7.2027L12.0083 7.27746C11.9529 7.31445 11.8779 7.29944 11.8409 7.24399L10.7241 5.56866C10.6871 5.51318 10.7022 5.43821 10.7577 5.40127L10.8702 5.32637C10.9257 5.28948 11.0006 5.30447 11.0376 5.35992Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M11.5058 5.04703L11.9452 5.70735C11.9822 5.76297 11.967 5.83806 11.9112 5.87489L11.7995 5.94872C11.7441 5.98536 11.6694 5.97029 11.6326 5.91497L11.1928 5.25552C11.1558 5.20007 11.1709 5.12512 11.2263 5.08815L11.3384 5.01345C11.3938 4.97645 11.4688 4.99147 11.5058 5.04703Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M12.1827 6.0653L12.6214 6.72426C12.6583 6.77966 12.6433 6.85447 12.588 6.89146L12.4766 6.96595C12.4211 7.00305 12.346 6.98807 12.3091 6.93251L11.8703 6.27355C11.8335 6.21815 11.8484 6.14334 11.9037 6.10634L12.0151 6.03186C12.0706 5.99475 12.1457 6.00971 12.1827 6.0653Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M4.62906 9.63235L5.74534 11.306C5.78231 11.3614 5.76738 11.4363 5.71193 11.4733L5.60015 11.548C5.54469 11.585 5.46974 11.57 5.43272 11.5146L4.31644 9.84093C4.27947 9.7855 4.2944 9.71058 4.34985 9.67358L4.46163 9.59893C4.51709 9.56191 4.59206 9.5769 4.62906 9.63235Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M4.16046 9.94535L4.59872 10.6027C4.63567 10.6581 4.62076 10.7329 4.56545 10.77L4.45427 10.8444C4.39884 10.8815 4.32381 10.8666 4.28676 10.8111L3.84797 10.1539C3.81095 10.0985 3.82588 10.0235 3.88133 9.9865L3.99306 9.91191C4.04849 9.87491 4.12346 9.88987 4.16046 9.94535Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M4.83773 10.9618L5.27649 11.6208C5.3134 11.6762 5.29844 11.7511 5.24307 11.788L5.13156 11.8626C5.07608 11.8996 5.00108 11.8847 4.96406 11.8292L4.52502 11.1703C4.48808 11.1148 4.50307 11.04 4.55844 11.003L4.67022 10.9283C4.72573 10.8912 4.80073 10.9062 4.83773 10.9618Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M3.69176 10.2583L4.80733 11.932C4.84427 11.9874 4.82932 12.0623 4.774 12.0993L4.66252 12.1739C4.60707 12.211 4.53206 12.196 4.49504 12.1405L3.37881 10.467C3.34182 10.4116 3.35683 10.3366 3.41228 10.2996L3.52445 10.2249C3.57984 10.1879 3.65479 10.2029 3.69176 10.2583Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M4.31664 7.34792L5.43276 5.67293C5.46976 5.61742 5.54473 5.60244 5.60021 5.63946L5.71197 5.71408C5.76739 5.75108 5.78232 5.826 5.74538 5.88142L4.62883 7.55549C4.59191 7.61081 4.51724 7.62585 4.46181 7.58915L4.35049 7.51546C4.29477 7.4786 4.27962 7.40349 4.31664 7.34792Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M3.84779 7.03549L4.96409 5.36017C5.00109 5.30466 5.07612 5.28968 5.1316 5.32676L5.24308 5.40129C5.29843 5.43829 5.31336 5.5131 5.27644 5.56853L4.16043 7.24394C4.12344 7.29944 4.04846 7.31446 3.99298 7.2774L3.8812 7.20278C3.8258 7.16581 3.81084 7.09092 3.84779 7.03549Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M3.37862 6.72422L4.49504 5.04723C4.53203 4.99169 4.60709 4.97668 4.66257 5.01376L4.77405 5.0883C4.8294 5.12529 4.84433 5.20005 4.80747 5.25548L3.69173 6.93271C3.65479 6.98825 3.57979 7.00329 3.52431 6.96629L3.41214 6.89154C3.35672 6.85457 3.34173 6.77967 3.37862 6.72422Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M10.2556 11.3059L10.6944 10.6487C10.7315 10.5932 10.8065 10.5783 10.8619 10.6154L10.9731 10.6898C11.0284 10.7269 11.0433 10.8017 11.0064 10.8571L10.5681 11.5144C10.5311 11.5699 10.4561 11.5849 10.4007 11.5479L10.289 11.4733C10.2335 11.4362 10.2186 11.3613 10.2556 11.3059Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M10.9324 10.2929L11.3719 9.63244C11.4089 9.57694 11.4838 9.5619 11.5393 9.59889L11.6513 9.67354C11.7068 9.71054 11.7218 9.78554 11.6848 9.841L11.2443 10.5004C11.2074 10.5557 11.1327 10.5707 11.0773 10.534L10.9662 10.4604C10.9106 10.4235 10.8954 10.3484 10.9324 10.2929Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M10.7241 11.6207L11.1632 10.9617C11.2001 10.9063 11.2751 10.8913 11.3306 10.9282L11.4428 11.0031C11.4982 11.0401 11.5132 11.1149 11.4763 11.1704L11.0375 11.8294C11.0006 11.8849 10.9257 11.8999 10.8702 11.863L10.7576 11.7881C10.7022 11.7511 10.6872 11.6762 10.7241 11.6207Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M11.4017 10.6024L11.841 9.945C11.878 9.88963 11.9528 9.8747 12.0083 9.91164L12.1204 9.9864C12.1759 10.0234 12.1909 10.0984 12.1538 10.1538L11.7145 10.8112C11.6776 10.8666 11.6027 10.8815 11.5473 10.8446L11.4351 10.7698C11.3795 10.7329 11.3646 10.6579 11.4017 10.6024Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M11.1929 11.9319L11.6325 11.2741C11.6694 11.2189 11.7439 11.2039 11.7993 11.2405L11.9111 11.3143C11.9668 11.3512 11.982 11.4263 11.945 11.4819L11.5057 12.1406C11.4688 12.196 11.3938 12.211 11.3384 12.1741L11.2263 12.0994C11.1708 12.0623 11.1558 11.9873 11.1929 11.9319Z",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M11.8706 10.9172L12.3091 10.2586C12.346 10.2031 12.4211 10.1881 12.4766 10.2252L12.5879 10.2996C12.6433 10.3367 12.6582 10.4116 12.6212 10.467L12.1824 11.1246C12.1455 11.18 12.0707 11.195 12.0153 11.1583L11.9043 11.0847C11.8487 11.0478 11.8336 10.9728 11.8706 10.9172Z",
    fill: "#464655"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKorean16);
export default __webpack_public_path__ + "static/media/icon-korean-16.95cd97019590e56b4e549052f58c7912.svg";
export { ForwardRef as ReactComponent };